var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPage = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.25 1.246C4.69772 1.246 4.25 1.69372 4.25 2.246V18.746C4.25 19.2983 4.69772 19.746 5.25 19.746H21.75C22.3023 19.746 22.75 19.2983 22.75 18.746V2.246C22.75 1.69372 22.3023 1.246 21.75 1.246H5.25ZM3.25 2.246C3.25 1.14143 4.14543 0.246 5.25 0.246H21.75C22.8546 0.246 23.75 1.14143 23.75 2.246V18.746C23.75 19.8506 22.8546 20.746 21.75 20.746H5.25C4.14543 20.746 3.25 19.8506 3.25 18.746V2.246Z",
  fill: "#000000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.75 3.246C1.02614 3.246 1.25 3.46986 1.25 3.746V21.746C1.25 22.0112 1.35536 22.2656 1.54289 22.4531C1.73043 22.6406 1.98478 22.746 2.25 22.746H20.25C20.5261 22.746 20.75 22.9699 20.75 23.246C20.75 23.5221 20.5261 23.746 20.25 23.746H2.25C1.71957 23.746 1.21086 23.5353 0.835786 23.1602C0.460714 22.7851 0.25 22.2764 0.25 21.746V3.746C0.25 3.46986 0.473858 3.246 0.75 3.246Z",
  fill: "#000000"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.75 6.746C7.75 6.46986 7.97386 6.246 8.25 6.246H18.75C19.0261 6.246 19.25 6.46986 19.25 6.746C19.25 7.02214 19.0261 7.246 18.75 7.246H8.25C7.97386 7.246 7.75 7.02214 7.75 6.746Z",
  fill: "#000000"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.75 9.746C7.75 9.46986 7.97386 9.246 8.25 9.246H18.75C19.0261 9.246 19.25 9.46986 19.25 9.746C19.25 10.0221 19.0261 10.246 18.75 10.246H8.25C7.97386 10.246 7.75 10.0221 7.75 9.746Z",
  fill: "#000000"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.75 12.746C7.75 12.4699 7.97386 12.246 8.25 12.246H15.75C16.0261 12.246 16.25 12.4699 16.25 12.746C16.25 13.0221 16.0261 13.246 15.75 13.246H8.25C7.97386 13.246 7.75 13.0221 7.75 12.746Z",
  fill: "#000000"
})));
export { SvgPage as ReactComponent };
export default __webpack_public_path__ + "images/page.svg";